import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "25",
  r: "20"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "12",
  rx: "3",
  ry: "3",
  width: "120",
  height: "6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "53",
  y: "28",
  rx: "3",
  ry: "3",
  width: "180",
  height: "7"
}, null, -1)

import { ContentLoader } from 'vue-content-loader';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkeletonLoader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ContentLoader), {
    viewBox: "0 0 253 50",
    speed: 1.3,
    width: "253",
    height: "50",
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 8, ["speed"]))
}
}

})